<script setup>
import { computed } from 'vue';

const props = defineProps({
    side: {
        type: String,
        required: true,
        validator: (value) => ['out', 'in'].includes(value),
    },
    variant: {
        type: String,
        default: 'thread',
        validator: (value) => ['thread', 'ai'].includes(value),
    },
});

/** WhatsApp Web fill paths (viewBox 0 0 8 13). */
const TAIL_OUT = {
    fill: 'M5.188,0H0v11.193l6.467-8.625C7.526,1.156,6.958,0,5.188,0z',
    stroke: 'M0,0.5H5.188C6.958,0.5,7.526,1.656,6.467,3.068L0,11.693',
    strokeAi: 'M0,1H5.188C6.958,1,7.526,2.156,6.467,3.568L0,12.193',
};
const TAIL_IN = {
    fill: 'M1.533,2.568L8,11.193V0L2.812,0C1.042,0,0.474,1.156,1.533,2.568z',
    stroke: 'M8,0.5H2.812C1.042,0.5,0.474,1.656,1.533,3.068L8,11.693',
    strokeAi: 'M8,1H2.812C1.042,1,0.474,2.156,1.533,3.568L8,12.193',
};

const tail = computed(() => (props.side === 'in' ? TAIL_IN : TAIL_OUT));
const strokePath = computed(() => (
    props.variant === 'ai' ? tail.value.strokeAi : tail.value.stroke
));
</script>

<template>
    <span
        class="ticket-desk-bubble-tail"
        :class="[
            `ticket-desk-bubble-tail--${side}`,
            variant === 'ai' ? 'ticket-desk-bubble-tail--ai' : null,
        ]"
        :data-testid="side === 'in' ? 'tail-in' : 'tail-out'"
        aria-hidden="true"
    >
        <svg
            viewBox="0 0 8 13"
            width="8"
            height="13"
            overflow="visible"
            preserveAspectRatio="xMidYMid meet"
            focusable="false"
            aria-hidden="true"
        >
            <path class="ticket-desk-bubble-tail__fill" :d="tail.fill" />
            <path class="ticket-desk-bubble-tail__stroke" :d="strokePath" />
        </svg>
    </span>
</template>
